// International listings — managed manually
export const internationalListings = [
  {
    id: 1,
    slug: "la-alqueria-benahavis-villa",
    title: "Spacious Villa with Panoramic Sea Views",
    subtitle: "La Alqueria, Benahavis",
    country: "Spain",
    region: "Costa del Sol",
    location: "La Alqueria, Benahavis, Marbella",
    price: 9000000,
    currency: "EUR",
    priceType: "sale",
    beds: 5,
    baths: 5,
    sqm: 1266,
    plotSqm: 2254,
    type: "Villa",
    featured: true,
    description: `Villa for sale in La Alqueria, Benahavis with 5 bedrooms, 5 bathrooms with private swimming pool, private garage (3 parking spaces) and private garden.

The property was built with top quality materials in order to reflect unique design of each room. The outdoor infinity pool has open views of the sea and mountains and is surrounded by jacuzzi and a chill out area with sun beds. Walking through the outdoor covered terrace you could find a BBQ area surrounded by green tropical garden.

Regarding property dimensions, it has 1,266 m² built and 2,254 m² plot.`,
    amenities: [
      "Air conditioning", "Barbeque", "Brand new", "Close to schools",
      "Covered terrace", "Double glazing", "Fitted wardrobes", "Fully fitted kitchen",
      "Garden view", "Golf view", "Gym", "Jacuzzi", "Lift", "Marble floors",
      "Panoramic view", "Private terrace", "Sea view", "SPA", "Storage room",
      "Uncovered terrace", "Utility room", "Amenities near", "Basement",
      "Close to golf", "Close to shops", "Dining room", "Fireplace",
      "Front line golf", "Fully furnished", "Glass Doors", "Guest toilet",
      "Home automation system", "Laundry room", "Living room", "Mountain view",
      "Pool view", "Sauna", "Solar panels", "Steam room", "Turkish bath",
      "Underfloor heating (bathrooms)", "Video entrance",
    ],
    images: [
      "/listings/la-alqueria/10.webp",
      "/listings/la-alqueria/09.webp",
      "/listings/la-alqueria/08.webp",
      "/listings/la-alqueria/06.webp",
      "/listings/la-alqueria/07.webp",
      "/listings/la-alqueria/01.webp",
      "/listings/la-alqueria/02.webp",
      "/listings/la-alqueria/03.webp",
      "/listings/la-alqueria/04.webp",
      "/listings/la-alqueria/05.webp",
    ],
    brochure: null,
  },
  {
    id: 2,
    slug: "villa-c44-phuket",
    title: "Premium Villa in Clover Residence",
    subtitle: "Villa C44, Phuket",
    country: "Thailand",
    region: "Phuket",
    location: "Clover Residence, Phuket, Thailand",
    price: 25900000,
    currency: "THB",
    priceType: "sale",
    beds: 3,
    baths: 3,
    sqm: 352,
    plotSqm: 485,
    type: "Villa",
    featured: true,
    description: `Villa C44 is a fully completed, turnkey premium villa in the Clover Residence community, Phuket. Ready to move in immediately.

Unique location — 50 m to HeadStart International School, 4.5 km to the sea. No neighbours on one side, ensuring exceptional privacy.

Total built area 351.80 m², green area 132.72 m², land plot 484.52 m². The villa features a private swimming pool, sunken lounge terrace, 3-car garage, master bedroom with ensuite, two additional bedrooms, and a spacious open-plan living, dining and kitchen area of 81.25 m².

Sold directly from the owner — THB 6 million below developer price. Construction supervised by an independent expert organisation; all reports and documentation transferred to the new owner.

Rental income: THB 2.5 million per year. Yield: 8–10%. Payment by bank transfer or cryptocurrency.`,
    amenities: [
      "Private swimming pool", "Sunken lounge seat", "3-car garage",
      "Master bedroom with ensuite", "Open-plan kitchen", "Storage room",
      "Pump room", "Modern interior", "Fully completed", "Ready to move in",
      "50m to HeadStart School", "Investment yield 8–10%",
    ],
    images: [
      "/listings/villa-c44/01.webp",
      "/listings/villa-c44/02.webp",
      "/listings/villa-c44/03.webp",
      "/listings/villa-c44/04.webp",
      "/listings/villa-c44/05.webp",
      "/listings/villa-c44/06.webp",
      "/listings/villa-c44/07.webp",
      "/listings/villa-c44/08.webp",
      "/listings/villa-c44/09.webp",
      "/listings/villa-c44/10.webp",
      "/listings/villa-c44/11.webp",
    ],
    brochure: null,
    pfUrl: "https://villac44.com",
  },
];
